import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Loader from '../../app/components/loader';
import { ProjectSchedule } from './projects-schedule';
import { ProjectsProvider } from './provider';
import moment from 'moment';
import { CardAvatarStack } from '@/components/ui/card-avatar-stack';
import { useTranslation } from 'react-i18next';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { DashboardContent } from '@/layouts/dashboard';
import { Widget } from '@/components/custom/widget';
import { PageContent, Page, PageSidebar } from '@/components/custom/page';
import { CourseAboutDescription, CourseAboutTitle, CourseBanner, CourseBannerCTA, CourseBannerDescription, CourseBannerTitle } from '@/components/custom/course';
import { Button } from '@/components/ui/button';
import { CardAvatar, CardAvatarTitle, CardKpiGrid } from '@/components/ui/card';

export function ProjectsAbout(props) {
  const { uri, groupId } = props;

  const { t } = useTranslation();
  const client = useClient();
  const { projectId } = useParams();
  const [project, setProject] = useState([]);
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [mentors, setMentors] = useState([]);

  const isStudent = useCheckIncludeProfiles({ only: ['student'] });

  const getProject = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`projects/${projectId}`);

    setLoading(false);
    if (error) {
      toast.error('Erro ao buscar projeto.');
    } else {
      setProject(data);

      if (data?.users && data?.users.length > 0) {
        setStudents(data.users.filter(u => u.profiles.includes('Aluno') && !u.profiles.includes('Professor') && !u.profiles.includes('Administrador')));

        setMentors(data.users.filter(u => u.profiles.includes('Professor') || u.profiles.includes('Administrador')));
      }
    }
  };

  const createProjectUser = async () => {
    const { data, error } = await client.mutate('project_users', {
      'project-id': projectId
    });
  };

  useEffect(() => {
    getProject();
  }, []);

  const studentBreadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: '/projetos',
        name: 'Projetos',
        isActive: false
      },
      {
        route: uri,
        name: 'Detalhamento',
        isActive: true
      }
    ]
  };

  const adminBreadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: '/projetos/grupos',
        name: 'Projetos',
        isActive: false
      },
      {
        route: `/projetos/grupos/${groupId}`,
        name: project?.name,
        isActive: false
      },
      {
        route: uri,
        name: 'Detalhamento',
        isActive: true
      }
    ]
  };

  const breadcrumbs = isStudent ? studentBreadcrumbs : adminBreadcrumbs;

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      {loading ? (
        <Loader />
      ) : (
        <Widget className="animate-fade-in">
          <CourseBanner className="mb-7">
            <CourseBannerTitle>{project && project.name}</CourseBannerTitle>
            <CourseBannerDescription>{`${t('projects.updatedIn')} ${moment(project['updated-at']).format(`MMMM [${t('projects.in')}] YYYY`)} | ${t('projects.by')} ${project.user?.name}`}</CourseBannerDescription>
            <CourseBannerCTA>
              <Button
                wide
                asChild
              >
                <Link
                  to={`/projetos/${projectId}`}
                  onClick={() => createProjectUser()}
                >
                  {t('button.accessProject')}
                </Link>
              </Button>
            </CourseBannerCTA>
          </CourseBanner>

          <Page className="gap-7">
            <PageContent>
              {/* <div className="tag-list">
                <div className="tag">Tag name</div>
              </div> */}

              <div className="mb-4">
                <CourseAboutTitle>{t('button.aboutProject')}</CourseAboutTitle>
                <CourseAboutDescription>{project && project.about}</CourseAboutDescription>
              </div>

              <div>
                <CourseAboutTitle>{t('projects.titleProjectParticipants')}</CourseAboutTitle>
                <CourseAboutDescription>
                  <CardKpiGrid>
                    <CardAvatar>
                      <CardAvatarTitle>{t('projects.titleTeachers')}</CardAvatarTitle>
                      {mentors?.length > 0 && (
                        <CardAvatarStack
                          data={mentors}
                          modalTitle={t('projects.titleProjectTeacher')}
                          size="md"
                        />
                      )}
                    </CardAvatar>
                    <CardAvatar>
                      <CardAvatarTitle>{t('projects.titleStudents')}</CardAvatarTitle>
                      {students?.length > 0 && (
                        <CardAvatarStack
                          data={students}
                          modalTitle={t('projects.titleProjectStudents')}
                          size="md"
                        />
                      )}
                    </CardAvatar>
                  </CardKpiGrid>
                </CourseAboutDescription>
              </div>
            </PageContent>

            <PageSidebar overflow={false}>
              <ProjectsProvider>
                <ProjectSchedule />
              </ProjectsProvider>
            </PageSidebar>
          </Page>
        </Widget>
      )}
    </DashboardContent>
  );
}
